<template>
  <div id="notification-list">
    <notification v-for="n in notificationList" :key="n.key" :notification="n"/>
  </div>
</template>

<script>
import Notification from './Notification.vue';

export default {
  components: {Notification},
  computed: {
    notificationList() {
      const n = this.$store.getters['notifications/notificationList'];
      
      n.forEach(x => x.key == Math.random());

      return n;
    }
  }
}
</script>
